import {
  SETDEVOPSSELECT,
  FILTERSELECT,
  SETPROGRESSBAR,
  USERAUTHORITY,
  OPENWEBSOCKET,
  SENDWEBSOCKET,
  CLOSEWEBSOCKET,
  SAVEWEBSOCKET,
  SCROLLTOBOTTOM,
  FILEEXPORT,
  SETDEVOPSSYSTEM,
  SETDEVOPSUSERLIST,
  SETDEVOPSSTATUSLIST,
  SETDEVOPSMENULIST,
  SETDEVOPSWORKORDERCONFIGLIST
} from './type'

let isRoll = true; // 滚动
export default {
  [SETDEVOPSSELECT](state, ret) {
    let obj = {
      TEXTUSERS: {},
      TEXTUSERSEN: {},
      TEXTALLUSERS: {},
      TEXTALLUSERSEN: {},
      TEXTORGS: {},
      TEXTORGSCHART: {},
      TEXTMODULES: {},
      TEXTFILTERMODULES: {},
      NEWTEXTMODULES: {},
      TEXTPSTATUS: {},
      TEXTTASKSTATUS: {},
      TEXTTASKSTATUSCHART: {},
      TEXTPISSUESTATUS: {},
      TEXTPRIORITY: {},
      TEXTTAGS: {},
      TEXTDOMAINS: {},
      NEWTEXTDOMAINS: {},
      TEXTPROJECTSYSTEM: {},
      TEXTOPERATORTASKSTATUS: {},
      CODESCANENGINE: {},
      MODULESARR: [],
      TEXTREVIEWSTATUS: {},
      TEXTECHNICALREVIEW: [],
      TEXTEDATALEVELREQUIREMENTS: [],
      TEXTECONCURRENCYREQUIREMENTS:[],
      TEXTERESPONSETIMEREQUIREMENTS:[],
      TEXTERESPONSETECHNICALDIFFICULTY:[],
      OTHERTASHOPERATOR:{},
      OTHERTASKSTATUS:{},
      BUGTASKPRIORITY:{},
      BUGTASKSTATUS:{},
      BUGTASHOPERATOR:{},
      NEWBUGTASHOPERATOR:{},
      USERCORD:{},
      USERPOSITION:{},
      AllUSERLISTEN:{},
      AllUSERLIST:{},
      NEWDEVOPSPROJECTSYSTEM:{},
      PROJECTSTATUS:{},
      GITLABPATAM:{}
    }
    // 技术难度
    obj['TEXTERESPONSETECHNICALDIFFICULTY'] = ret["devops-response-technical-difficulty"]
    // 响应时间要求
    obj['TEXTERESPONSETIMEREQUIREMENTS'] = ret["devops-response-time-requirements"]
    // 并发量要求
    obj['TEXTECONCURRENCYREQUIREMENTS'] = ret["devops-concurrency-requirements"]
    // 响应量级要求
    obj['TEXTEDATALEVELREQUIREMENTS'] = ret["devops-data-level-requirements"]
    // 技术负责人
/*    ret["devops-project-technical-review"].forEach((item) => {
      obj['TEXTECHNICALREVIEW'][item['project_system_name']] = item['project_technical_reviewer']
    });*/
    // 技术评审状态
    ret["devops-review-status"].forEach((item) => {
      obj['TEXTREVIEWSTATUS'][item[1]] = item[0]
    });
    /*  // 人员
      ret["devops-project-allusers"].forEach((item) => {
        obj['TEXTALLUSERSEN'][item[0]] = `${item[1]}（${item[0]}）`
        obj['TEXTALLUSERS'][item[0]] = item[1]
      });*/
    /*ret["devops-tasklist-users"].forEach((item) => {
      obj['TEXTUSERSEN'][item[1]] = `${item[0]}（${item[1]}）`
      obj['TEXTUSERS'][item[1]] = item[0]
    });*/
    // 项目系统
    ret["devops-project-system"].forEach((item) => {
      obj['TEXTPROJECTSYSTEM'][item[1]] = item[0]
    });
    ret["git-param"].forEach((item) => {
      obj['GITLABPATAM'][item[1]] = item[0]
    });

    // 开发团队
    ret["devops-tasklist-org"].forEach((item) => {
      obj['TEXTORGS'][item[0]] = item[1]
    });
    // 开发团队 - chart
    ret["devops-org"].forEach((item) => {
      obj['TEXTORGSCHART'][item[0]] = item[1]
    });
    // 系统
    obj['MODULESARR'] = ret["devops-tasklist-module"]
    ret["devops-tasklist-module"].forEach((item) => {
      obj['TEXTMODULES'][item[1]] = item[0]
      obj['TEXTFILTERMODULES'][item[1]] = item[0]
      obj['NEWTEXTMODULES'][item[0]] = item[1]
    });
    // 方案状态
    ret["devops-project-status"].forEach((item, index) => {
      if (item[1] == 'all') return;
      obj['TEXTPSTATUS'][item[1]] = item[0]
    });
    // 需求状态
    ret["devops-project-issue-status"].forEach((item) => {
      obj['TEXTPISSUESTATUS'][item[1]] = item[0]
    });
    // 任务状态
    ret["devops-task-status"].forEach((item) => {
      obj['TEXTTASKSTATUS'][item[0]] = item[1]
    });
    // 任务状态 - chart
    ret["devops-task-status-echarts"].forEach((item) => {
      obj['TEXTTASKSTATUSCHART'][item[0]] = item[1]
    });
    // 优先级
    ret["devops-tasklist-priority"].forEach((item) => {
      obj['TEXTPRIORITY'][item[0]] = item[1]
    });
    // 标签
    ret["devops-project-tags"].forEach((item) => {
      obj['TEXTTAGS'][item[1]] = item[0]
    });

    // 域名
    ret["tester_testCodeDeploy-domain"].forEach((item) => {
      obj['TEXTDOMAINS'][item[1]] = `${item[0]}(${item[1]})`
      obj['NEWTEXTDOMAINS'][item[0]+'('+item[1]+')'] = item[1];
    });

    // 运维空间任务状态
    ret["operator-task-status"].forEach((item) => {
      obj['TEXTOPERATORTASKSTATUS'][item[1]] = `${item[0]}`
    });

    // 代码质量检测引擎
    ret["devops-task-codescan-engine"].forEach((item) => {
      obj['CODESCANENGINE'][item[1]] = item[0]
    });
    // 其他任务类型
    ret["other_task_operator"].forEach((item) => {
      obj['OTHERTASHOPERATOR'][item[0]] = item[1]
    });
    // 其他任务状态
    ret["other_task_status"].forEach((item) => {
      obj['OTHERTASKSTATUS'][item[0]] = item[1]
    });
    //bug 任务状态
    ret["bug_task_status"].forEach((item) => {
      obj['BUGTASKSTATUS'][item[0]] = item[1]
    });
    // bug严重程度
    ret["bug_task_priority"].forEach((item) => {
      obj['BUGTASKPRIORITY'][item[0]] = item[1]
    });
    // bug任务类型
    ret["bug_task_type"].forEach((item) => {
      obj['BUGTASHOPERATOR'][item[0]] = item[1]
    });
    // bug任务类型
    ret["bug_task_type"].forEach((item) => {
      obj['NEWBUGTASHOPERATOR'][item[1]] = item[0]
    });
    /*// 所有用户组
    ret["user_cord"].forEach((item) => {
      obj['USERCORD'][item[1]] = item[0]
    });*/
    // 用户角色
    /*ret["user_position"].forEach((item) => {
      obj['USERPOSITION'][item[1]] = item[0]
    });*/
    /* 以下是增加项目要新增的 2023-11-16*/
    //公司所有人员
    /*ret["all_user_list"].forEach((item) => {
      obj['AllUSERLISTEN'][item[1]] = `${item[0]}（${item[1]}）`
      obj['AllUSERLIST'][item[1]] = item[0]
    });*/
    //项目体系
    // 项目系统
/*    ret["new_project_system_list"].forEach((item) => {
      obj['NEWDEVOPSPROJECTSYSTEM'][item[1]] = item[0]
    });*/
    // 项目状态
/*    ret["project_status"].forEach((item) => {
      obj['PROJECTSTATUS'][item[1]] = item[0]
    });*/
    Object.keys(obj).forEach(itm => {
      state.ALLSELECT[itm] = obj[itm];
    })
    window.localStorage.setItem('GITLABPATAM',JSON.stringify(obj.GITLABPATAM));
  },
  [FILTERSELECT](state, { type = '', val = '' }) {
    if (type === 'domain_module') {
      let obj = {}, arr = [];
      if (val.length) {
        val.map((item) => {
          state.ALLSELECT['MODULESARR'].forEach((itm) => {
            if (itm[2] === item) {
              arr.push(itm)
            }
          })
        })
        arr.forEach((item) => {
          obj[item[1]] = item[0]
        });
        state.ALLSELECT['TEXTFILTERMODULES'] = obj;
      } else {
        state.ALLSELECT['TEXTFILTERMODULES'] = state.ALLSELECT['TEXTMODULES'];
      }
    }
  },
  [SETPROGRESSBAR](state, { percentage = 0, customColor = '#1989fa', completeInfo = '', status = '', title = '' }) {
    state.PROGRESSSBAR = {
      customColor,
      completeInfo,
      percentage,
      title,
      status // 失败 exception 成功 success
    }
  },
  [USERAUTHORITY](state, { user = '', user_pm = '', user_qa = '' }) {
    state.USER.authority = (user === user_pm || user === user_qa)
  },
  [OPENWEBSOCKET](state, { url = '', params = {}, title = '', apiCount = 1 }) {
    url = process.env['NODE_ENV'] === 'development' ? `wss://devops-test.ehsy.com${url}` : `wss://${window.location.origin.split('//')[1]}${url}`
    this.commit(SETPROGRESSBAR, {})
    state.WEBSOCKET = { url, params, msg: '', percent: 0, title, apiCount }
  },
  [SENDWEBSOCKET](state, { params = {}, title = '' }) {
    const { percent = 0, url = '', msg = '', apiCount = 1 } = state.WEBSOCKET
    this.commit(SETPROGRESSBAR, { percentage: percent, title })
    state.WEBSOCKET = { url, params, msg, percent, title, apiCount }
  },
  [CLOSEWEBSOCKET](state) {
    isRoll = true;
    this.commit(SETPROGRESSBAR, {})
    state.WEBSOCKET = { url: '', params: {}, msg: '', percent: 0, title: '', apiCount: 1 }
  },
  [SAVEWEBSOCKET](state, data = {}) {
    const { percent = 0, msg = '', } = data;
    const { url = '', params = {}, title = '', percent: oldPercent = 0, apiCount = 1 } = state.WEBSOCKET;
    // var ansi_up = new AnsiUp();
    // var html = ansi_up.ansi_to_html(msg)
    let newPercent = 0;
    if (apiCount === 1) {
      newPercent = percent;
    }
    if (apiCount === 2) {
      const currentPercent = Math.floor(percent / apiCount)
      newPercent = oldPercent >= 100 / apiCount ? 50 + currentPercent : currentPercent;
    }
    if (percent > 0) {
      // 接收的信息有进度条信息
      this.commit(SETPROGRESSBAR, { percentage: newPercent, title })
    }
    state.WEBSOCKET = { url, params: params, msg: state.WEBSOCKET.msg + msg, percent: percent ? newPercent : oldPercent, title, apiCount }
  },
  // 自动滚动到底部
  [SCROLLTOBOTTOM](state, { bind, refName }) {
    bind.$nextTick(() => {
      const $el = bind.$refs[refName]
      if ($el) {
        $el.addEventListener('scroll', () => {
          // console.log($el.scrollTop, $el.clientHeight, $el.scrollHeight)
          isRoll = $el.scrollTop + $el.clientHeight > ($el.scrollHeight - 1)
        })
        if (isRoll) {
          $el.scrollTop = $el.scrollHeight;
        }
      }
    })
  },
  // 文件导出
  [FILEEXPORT](state, form) {
    const username = '';
    let url = `${window.location.origin}/devops/space/reporter/export?username=${username}`;
    // let url = `https://tops2-test.ehsy.com/devops/space/reporter/export?username=${username}`;
    for (const key in form) {
      const val = form[key];
      url += `&${key}=${Object.prototype.toString.call(val) === '[object Array]' ? val.toString() : val}`;
    }
    window.location.href = url;
  },
  //以下是新增的 2023-11-23
  //项目体系
  [SETDEVOPSSYSTEM](state, ret){
    let ALLSYSTEM = {
      ALLSYSTEMIDS:{},
      ALLSYSTEMEN:{},
      NEWALLSYSTEMIDS:[],
    };
    ret["data"].forEach((item) => {
      ALLSYSTEM['ALLSYSTEMIDS'][item.id] = item['nameZh'];
      ALLSYSTEM['ALLSYSTEMEN'][item.id] = item['nameEn'];
      ALLSYSTEM['NEWALLSYSTEMIDS'][item.id] = item['nameZh'];
    });
    state.ALLSYSTEM = ALLSYSTEM;
    window.localStorage.setItem('ALLSYSTEM',JSON.stringify(ALLSYSTEM));
  },
  [SETDEVOPSUSERLIST](state, ret){
    if(ret.data){
      ret.data=ret.data.filter(item=>item.id!=374) // 去掉id为374的人
    }
    const userId = state.userInfo.userId || '3469';
    /*
    * 2.产品经理
      3.开发人员
      4.测试人员
      5.技术负责人
      6.前端-中端主管
      7.测试主管
      8.后端主管
      9.技术总监
      10.项目总监
      11.架构师
      12.运维人员*/
    let ALLUSERLIST = {
      ALLUSERTYPE1: {},
      ALLUSERTYPE2: {},
      ALLUSERTYPE3: {},
      ALLUSERTYPE4: {},
      ALLUSERTYPE5: {},
      ALLUSERTYPE6: {},
      ALLUSERTYPE7: {},
      ALLUSERTYPE8: {},
      ALLUSERTYPE9: {},
      ALLUSERTYPE10: {},
      ALLUSERTYPE11: {},
      ALLUSERTYPE12: {},
      ALLUSERIDLIST1: {},
      DEVUSER: {},
      DEVUSERUSER: {},
      ALLUSERTYPE13: {},
      LEADERUSER: {},
      MYROLES: {},

    };/*

    let typeStr = 'ALLUSERTYPE'+ret.userType;
    let IdtypeStr = 'ALLUSERIDLIST'+ret.userType;
    ALLUSERLIST[typeStr] = {};
    ALLUSERLIST[IdtypeStr] = {};*/
    ret["data"].forEach((item) => {
      if(item.user_type === 1) ALLUSERLIST['ALLUSERTYPE1'][item.id] = item['user_name'];
      if(item.user_type === 2) ALLUSERLIST['ALLUSERTYPE2'][item.id] = item['user_name'];
      if(item.user_type === 3) ALLUSERLIST['ALLUSERTYPE3'][item.id] = item['user_name'];
      if(item.user_type === 4) ALLUSERLIST['ALLUSERTYPE4'][item.id] = item['user_name'];
      if(item.user_type === 5) ALLUSERLIST['ALLUSERTYPE5'][item.id] = item['user_name'];
      if(item.user_type === 6) ALLUSERLIST['ALLUSERTYPE6'][item.id] = item['user_name'];
      if(item.user_type === 7) ALLUSERLIST['ALLUSERTYPE7'][item.id] = item['user_name'];
      if(item.user_type === 8) ALLUSERLIST['ALLUSERTYPE8'][item.id] = item['user_name'];
      if(item.user_type === 9) ALLUSERLIST['ALLUSERTYPE9'][item.id] = item['user_name'];
      if(item.user_type === 10) ALLUSERLIST['ALLUSERTYPE10'][item.id] = item['user_name'];
      if(item.user_type === 11) ALLUSERLIST['ALLUSERTYPE11'][item.id] = item['user_name'];
      if(item.user_type === 12) ALLUSERLIST['ALLUSERTYPE12'][item.id] = item['user_name'];
      if(item.user_type === 1) ALLUSERLIST['ALLUSERIDLIST1'][item.devops_name] = item['id'];
      if(item.user_type !== 1 && item.user_type !== 13) ALLUSERLIST['DEVUSER'][item.id] = item['user_name'];
      if(item.user_type !== 1) ALLUSERLIST['DEVUSERUSER'][item.devops_name] = item['id'];
      //管理员
      if(item.user_type === 13) ALLUSERLIST['ALLUSERTYPE13'][item.devops_name] = item['id'];
      //上级领导
      if(item.user_type !== 1 && item.user_type !== 13 && item.p_id) ALLUSERLIST['LEADERUSER'][item.id] = item['p_id'];
      // ALLUSERLIST[IdtypeStr][item.nameEn] = item['id'];
      if(userId == item['id'])  ALLUSERLIST['MYROLES'][item.user_type] = item['role_name'];
    });
    state.ALLUSERLIST = ALLUSERLIST;
    window.localStorage.setItem('ALLUSERLIST',JSON.stringify(ALLUSERLIST));
  },

  [SETDEVOPSSTATUSLIST](state, ret){
    /*

    1.项目状态
    2.需求状态
    3.开发任务状态
    4.测试任务状态
    5.缺陷任务状态
    6.其他任务状态
    * */
    let ALLSTATUSLIST = {
      ALLSTATUSTYPE1: {},
      ALLSTATUSTYPE2: [],
      ALLSTATUSTYPE3: {},
      ALLSTATUSTYPE4: [],
      ALLSTATUSTYPE5: {},
      ALLSTATUSTYPE6: {},
    };
    /* if(state.ALLSTATUSLIST){
       ALLSTATUSLIST =  state.ALLSTATUSLIST;
     }
     let typeStr = 'ALLSTATUSTYPE'+ret.type;
     ALLSTATUSLIST[typeStr] = {};*/
    let ALLSTATUSTYPE4PART = [];
    ret["data"].forEach((item) => {
      if(item.type === 1) ALLSTATUSLIST['ALLSTATUSTYPE1'][item.code] = item['statusDesc'];
      if(item.type === 2) ALLSTATUSLIST['ALLSTATUSTYPE2'].push({key:item.code,value:item.statusDesc});
      if(item.type === 3) ALLSTATUSLIST['ALLSTATUSTYPE3'][item.code] = item['statusDesc'];
      //if(item.type === 4) ALLSTATUSLIST['ALLSTATUSTYPE4'][item.code] = item['statusDesc'];
      if(item.type === 4 && (item.code < 6 || item.code === 9)) ALLSTATUSLIST['ALLSTATUSTYPE4'].push({key:item.code,value:item.statusDesc});
      if(item.type === 4 && (item.code > 5 && item.code !== 9)) ALLSTATUSTYPE4PART.push({key:item.code,value:item.statusDesc});
      if(item.type === 5) ALLSTATUSLIST['ALLSTATUSTYPE5'][item.code] = item['statusDesc'];
      if(item.type === 6) ALLSTATUSLIST['ALLSTATUSTYPE6'][item.code] = item['statusDesc'];
    });
    ALLSTATUSLIST['ALLSTATUSTYPE4'] = [...ALLSTATUSLIST['ALLSTATUSTYPE4'],...ALLSTATUSTYPE4PART];
    state.ALLSTATUSLIST = ALLSTATUSLIST;
    window.localStorage.setItem('ALLSTATUSLIST',JSON.stringify(ALLSTATUSLIST));
  },

  [SETDEVOPSMENULIST](state, ret){
    let ALLMENULIST = {
    };
    //循环首页
    ret["data"]["btnList"].forEach((item,index)=>{
        ALLMENULIST[item.code] = 1;
    })
    state.ALLMENULIST = ALLMENULIST;
    window.localStorage.setItem('ALLMENULIST',JSON.stringify(ALLMENULIST));
  },
  [SETDEVOPSWORKORDERCONFIGLIST](state, ret){
    let WORKORDERCONFIG = {
        STATUS:{},
        SYSTEM:{},
        LEVEL:{},
        CATEGORY:[],
        DEMANDTYPE:{},
        WORDERORDERTYPE:{},
    };
    //循环首页
    ret["data"].forEach((item,index)=>{
      if (item.type === 1) {
        WORKORDERCONFIG.STATUS[item.key]= item.value;
      }else if(item.type === 2){
        WORKORDERCONFIG.LEVEL[item.key]= item.value;
      }else if(item.type === 4){
        WORKORDERCONFIG.SYSTEM[item.key]= item.value;
      }else if(item.type === 5){
        WORKORDERCONFIG.WORDERORDERTYPE[item.key]= item.value;
      }else if(item.type === 6){
        WORKORDERCONFIG.CATEGORY.push({key:item.key,value:item.value});
      }else if(item.type === 7){
        WORKORDERCONFIG.DEMANDTYPE[item.key]= item.value;
      }
    })
    state.WORKORDERCONFIG = WORKORDERCONFIG;
  },
  SET_TOKEN:(state,token)=>{
      state.token = token;
      window.localStorage.setItem('token',token);
    },
    SET_USER_INFO:(state,userInfo)=>{
      state.userInfo = userInfo;
      window.localStorage.setItem('userInfo',JSON.stringify(userInfo));
    },
    SET_MENU_LIST:(state,menuList)=>{
      state.menuList = menuList;
      window.localStorage.setItem('menuList',JSON.stringify(menuList));
    },
}
